<div class="content-body">
  <div class="container-fluid">
    <app-breadcrumb [breadcrumb]="breadcrumb"></app-breadcrumb>

    <!-- Tabs -->
    <div class="card">
      <div class="card-header p-0 border-bottom-0">
        <ul class="nav nav-tabs card-header-tabs ms-0">
          <li class="nav-item">
            <button class="nav-link" [ngClass]="{ active: activeTab === 'document' }" (click)="setTab('document')">
              Document Templates
            </button>
          </li>
          <li class="nav-item">
            <button class="nav-link" [ngClass]="{ active: activeTab === 'notification' }" (click)="setTab('notification')">
              Notification Templates
            </button>
          </li>
        </ul>
      </div>

      <!-- ── DOCUMENT TEMPLATES ──────────────────────────────────── -->
      <div *ngIf="activeTab === 'document'" class="card-body p-0">
        <div class="template-layout">

          <!-- Left: template list -->
          <div class="template-list">
            <div class="template-list-header">Document Templates</div>
            <div
              *ngFor="let t of documentTemplates"
              class="template-list-item"
              [ngClass]="{ active: selectedDocTemplate?.id === t.id }"
              (click)="selectDocTemplate(t)"
            >
              <div class="template-code">{{ t.code }}</div>
              <div class="template-type text-muted small">{{ t.type | uppercase }}</div>
            </div>
            <div *ngIf="documentTemplates.length === 0" class="p-3 text-muted small">
              No document templates found.
            </div>
          </div>

          <!-- Right: editor -->
          <div class="template-editor" *ngIf="selectedDocTemplate; else noDocSel">
            <div class="editor-toolbar">
              <span class="fw-semibold">{{ selectedDocTemplate.code }}</span>
              <div class="ms-auto d-flex gap-2">
                <button class="btn btn-sm btn-outline-secondary" (click)="toggleDocPreview()">
                  {{ docShowPreview ? 'Hide Preview' : 'Show Preview' }}
                </button>
                <button class="btn btn-sm btn-primary" (click)="saveDocTemplate()" [disabled]="docSaving">
                  <span *ngIf="docSaving" class="spinner-border spinner-border-sm me-1"></span>
                  Save
                </button>
              </div>
            </div>

            <div class="editor-body" [ngClass]="{ 'split-view': docShowPreview }">
              <!-- HTML editor -->
              <div class="editor-pane">
                <div class="pane-label">HTML</div>
                <textarea
                  class="code-editor"
                  [(ngModel)]="docHtml"
                  spellcheck="false"
                  autocomplete="off"
                ></textarea>
              </div>

              <!-- Preview pane -->
              <div class="preview-pane" *ngIf="docShowPreview">
                <div class="pane-label d-flex align-items-center justify-content-between">
                  Preview
                  <button class="btn btn-xs btn-outline-secondary" (click)="renderDocPreview()">Refresh</button>
                </div>
                <iframe #docPreviewFrame class="preview-iframe" sandbox="allow-same-origin allow-scripts"></iframe>
              </div>
            </div>
          </div>

          <ng-template #noDocSel>
            <div class="template-editor d-flex align-items-center justify-content-center text-muted">
              Select a template to edit.
            </div>
          </ng-template>
        </div>
      </div>

      <!-- ── NOTIFICATION TEMPLATES ─────────────────────────────── -->
      <div *ngIf="activeTab === 'notification'" class="card-body p-0">
        <div class="template-layout">

          <!-- Left: template list -->
          <div class="template-list">
            <div class="template-list-header">Notification Templates</div>
            <div
              *ngFor="let t of notificationTemplates"
              class="template-list-item"
              [ngClass]="{ active: selectedNotifTemplate?.id === t.id }"
              (click)="selectNotifTemplate(t)"
            >
              <div class="template-code">{{ t.action_name }}</div>
              <div class="template-type text-muted small">
                <span class="badge-channel" [ngClass]="'channel-' + t.channel">{{ t.channel }}</span>
              </div>
            </div>
            <div *ngIf="notificationTemplates.length === 0" class="p-3 text-muted small">
              No notification templates found.
            </div>
          </div>

          <!-- Right: editor -->
          <div class="template-editor" *ngIf="selectedNotifTemplate; else noNotifSel">
            <div class="editor-toolbar">
              <span class="fw-semibold">{{ selectedNotifTemplate.action_name }}</span>
              <span class="badge-channel ms-2" [ngClass]="'channel-' + selectedNotifTemplate.channel">
                {{ selectedNotifTemplate.channel }}
              </span>
              <div class="ms-auto d-flex gap-2">
                <button class="btn btn-sm btn-outline-secondary" (click)="toggleNotifPreview()">
                  {{ notifShowPreview ? 'Hide Preview' : 'Show Preview' }}
                </button>
                <button class="btn btn-sm btn-primary" (click)="saveNotifTemplate()" [disabled]="notifSaving || notifForm.invalid">
                  <span *ngIf="notifSaving" class="spinner-border spinner-border-sm me-1"></span>
                  Save
                </button>
              </div>
            </div>

            <div class="notif-editor-body">
              <!-- Meta fields -->
              <form [formGroup]="notifForm" class="notif-meta-fields">
                <div class="row g-3">
                  <div class="col-md-4">
                    <label class="form-label">Subject</label>
                    <input type="text" class="form-control form-control-sm" formControlName="subject" placeholder="Email subject" />
                  </div>
                  <div class="col-md-4">
                    <label class="form-label">From Name</label>
                    <input type="text" class="form-control form-control-sm" formControlName="from_name" placeholder="Sender display name" />
                  </div>
                  <div class="col-md-4">
                    <label class="form-label">From Email</label>
                    <input
                      type="email"
                      class="form-control form-control-sm"
                      formControlName="from_email"
                      placeholder="sender@example.com"
                      [ngClass]="{ 'is-invalid': notifForm.get('from_email')?.invalid && notifForm.get('from_email')?.dirty }"
                    />
                    <div class="invalid-feedback">Enter a valid email address.</div>
                  </div>
                </div>
              </form>

              <!-- Body editor + preview -->
              <div class="editor-body mt-3" [ngClass]="{ 'split-view': notifShowPreview }">
                <div class="editor-pane">
                  <div class="pane-label">Body (HTML)</div>
                  <textarea
                    class="code-editor"
                    [formControl]="$any(notifForm.get('body'))"
                    spellcheck="false"
                    autocomplete="off"
                  ></textarea>
                </div>

                <div class="preview-pane" *ngIf="notifShowPreview">
                  <div class="pane-label d-flex align-items-center justify-content-between">
                    Preview
                    <button class="btn btn-xs btn-outline-secondary" (click)="renderNotifPreview()">Refresh</button>
                  </div>
                  <iframe #notifPreviewFrame class="preview-iframe" sandbox="allow-same-origin allow-scripts"></iframe>
                </div>
              </div>
            </div>
          </div>

          <ng-template #noNotifSel>
            <div class="template-editor d-flex align-items-center justify-content-center text-muted">
              Select a template to edit.
            </div>
          </ng-template>
        </div>
      </div>

    </div><!-- /card -->
  </div>
</div>
